<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Pedidos que consumen Stock</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Pedidos que consumen Stock</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">

    <div class="container-custom-content">
        <div class="container-fluid">
            <div class="row align-items-center justify-content-evenly">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                    <mat-form-field color="accent-darker" appearance="standard">
                        <mat-label>{{Etiquetas.Buscar}}</mat-label>
                        <input matInput (keyup)="applyFilter($event)" #input>
                    </mat-form-field>
                    <div class="mat-table-stock-pedidos">
                        <table mat-table matTableResponsive [dataSource]="dataSource" matSort matSortActive="nroPedido"
                            matSortDirection="asc">



                            <ng-container matColumnDef="nroPedido">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro. pedido
                                </th>
                                <td mat-cell *matCellDef="let s">
                                    {{s.nroPedido}} </td>
                            </ng-container>

                            <ng-container matColumnDef="tipoEntrega">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo entrega
                                </th>
                                <td mat-cell *matCellDef="let s">
                                    {{s.tipoEntrega}} </td>
                            </ng-container>

                            <ng-container matColumnDef="cantidad">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cantidad
                                </th>
                                <td mat-cell *matCellDef="let s">
                                    {{s.cantidad | number : '1.3-3'}} </td>
                            </ng-container>


                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let p; columns: displayedColumns;">
                            </tr>


                            <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                <td class="mat-cell" [attr.colspan]="displayedColumns.length">{{Etiquetas.SinRegistros}}
                                </td>
                            </tr>
                        </table>

                        <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                        </mat-paginator>
                    </div>

                </div>

            </div>

        </div>

    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">

    <button mat-dialog-close mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>
